import React from 'react';

const ZipCodeProjectLocationOptionGroup = ({ children }) => children.length > 0 && (

  <div id="ZipCodeProjectLocation" className="card-content">
    <div className="row-header">
      <div className="row-header__title">
        <div className="sui-h2-bold sui-line-clamp-unset sui-text-primary">
          Set Your Project Location
        </div>
      </div>
    </div>
    <div className="headless">{children}</div>
  </div>
);

export default ZipCodeProjectLocationOptionGroup;
